import { LoadState } from "../../../constants/enums";

export interface IFiscalPeriodsState {
  list: IFiscalPeriodList[];
  loading: LoadState;
  totalRecords: number;
  data: IFiscalPeriod[];
  dataLoading: LoadState;
  error: string | null;
}

export interface IFiscalPeriodList {
  fiscal_years_code: string | null
}

export interface IFiscalPeriod {
  comment: string | null;
  create_ts: string | null;
  created_by_id: string | null;
  created_by_name: string | null;
  fiscal_year_month_id: string | null;
  from: string | null;
  insert_ts: string | null;
  modified_by_id:string | null;
  modified_by_name:string | null;
  period: string | null;
  fiscal_years_code: string | null;
  status: string | null;
  to: string | null;
  fiscal_year_month_code: string | null;
  year: string | null;
}

export const initialFiscalPeriodsState: IFiscalPeriodsState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  data: [],
  dataLoading: LoadState.NotLoaded,
  error: null,
};
